
import p1 from "./PasoB1.png";
import p2 from "./PasoB2.png";

import M_sub1_ac1 from "./M_sub1_ac1.png";
import M_sub1_ac2 from "./M_sub1_ac2.png";
import M_sub1_ac3 from "./M_sub1_ac3.png";
import M_sub1_ac4 from "./M_sub1_ac4.png";

import M_sub2_ac1 from "./M_sub2_ac1.png";
import M_sub2_ac2 from "./M_sub2_ac2.png";
import M_sub2_ac3 from "./M_sub2_ac3.png";

import Phone_1 from "./Phone_1.png";
import Phone_2 from "./Phone_2.png";
import Phone_3 from "./Phone_3.png";
import Phone_4 from "./Phone_4.png";
import Phone_5 from "./Phone_5.png";
import Phone_6 from "./Phone_6.png";

import Phone_quiz_1 from "./Phone_quiz_1.png";
import Phone_quiz_2 from "./Phone_quiz_2.png";
import Phone_quiz_3 from "./Phone_quiz_3.png";

import Monitor_1 from "./M_sub4_1.png";
import Monitor_2 from "./M_sub4_2.png";
import Monitor_3 from "./M_sub4_3.png";
import Monitor_4 from "./M_sub4_4.png";
import Monitor_5 from "./M_sub4_5.png";
import Monitor_6 from "./M_sub4_6.png";
import Monitor_7 from "./M_sub4_7.png";
import Monitor_8 from "./M_sub4_8.png";
import Monitor_9 from "./M_sub4_9.png";

import Phone_Spin from "./Phone_Spin.png";

import Monitor_5_1 from "./Monitor_5_1.png";
import Monitor_5_2 from "./Monitor_5_2.png";
import Monitor_5_3 from "./Monitor_5_3.png";

export const textureAct = {
	intro: {
		p1,
		p2
	},
	topic1_act_1: {
		M_sub1_ac1,
		M_sub1_ac2,
		M_sub1_ac3,
		M_sub1_ac4,
	},
	topic2_act_2: {
		M_sub2_ac1,
		M_sub2_ac2,
		M_sub2_ac3,
	},
	topic3_act_1: {
		Phone_1
	},
	topic3_act_2: {
		Phone_2,
		Phone_3,
		Phone_4,
		Phone_5,
		Phone_6,
	},
	topic3_act_3: {
		Phone_quiz_1,
		Phone_quiz_2,
		Phone_quiz_3,
	},
	topic4: {
		Monitor_1,
		Monitor_2,
		Monitor_3,
		Monitor_4,
		Monitor_5,
		Monitor_6,
		Monitor_7,
		Monitor_8,
		Monitor_9,
	},
	topic5: {
		Phone_Spin,
		Monitor_5_1,
		Monitor_5_2,
		Monitor_5_3,
	}
}